import { render, staticRenderFns } from "./CO2StorageCapacity.vue?vue&type=template&id=7dbd8528&"
import script from "./CO2StorageCapacity.vue?vue&type=script&lang=js&"
export * from "./CO2StorageCapacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports